var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStateError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 289.6 187",
    style: {
      enableBackground: "new 0 0 289.6 187"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.25;}\n\t.st1{fill:url(#Union_8_00000139989287054553259990000016621584592723351688_);}\n\t.st2{fill:url(#Union_6_00000096761933407825260150000017544701033375384984_);}\n\t.st3{fill:url(#Rectangle_474_00000086659823634388428640000005908936877478664078_);}\n\t.st4{fill:url(#Rectangle_484_00000177473527240209484370000015267151356606145430_);}\n\t.st5{fill:url(#Ellipse_433_00000049190355373274570310000003914750686217295022_);}\n\t.st6{opacity:0.25;fill:url(#Ellipse_51-2_00000101818763752064552810000011602453371066077603_);enable-background:new    ;}\n\t.st7{opacity:0.5;fill:url(#Ellipse_50-2_00000005955145193881154620000003504702496950392733_);enable-background:new    ;}\n\t.st8{opacity:0.75;fill:url(#Ellipse_49-2_00000097468956329739925970000014268766253042241427_);enable-background:new    ;}\n\t.st9{fill:url(#Path_16690-2_00000093867382687206140610000012078325058114352007_);}\n\t.st10{fill:url(#Exclusion_3_00000015325649404682300110000007568186878269161391_);}\n\t.st11{fill:url(#Union_11_00000110452870494725762970000017470689876738417572_);}\n\t.st12{fill:url(#Union_12_00000159466169267978738690000011322865150008945582_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_4878",
    transform: "translate(-17436.185 -17753.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3546",
    transform: "translate(17428.23 17819.729)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Union_8_00000034060040985962934830000018355899221513626769_",
    gradientUnits: "userSpaceOnUse",
    x1: -142.2594,
    y1: 443.7242,
    x2: -142.2594,
    y2: 442.7242,
    gradientTransform: "matrix(118.236 0 0 -40.121 16887.75 17865.8555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#FF5656"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    style: {
      fill: "url(#Union_8_00000034060040985962934830000018355899221513626769_)"
    },
    d: "M72.4,103.3H14.7 c-3.5,0-6.3-2.8-6.3-6.3c0,0,0,0,0,0v-0.8c0-3.5,2.8-6.3,6.3-6.3h39.5c3.7-0.1,6.6-3.2,6.5-6.8c-0.1-3.6-3-6.5-6.7-6.5h-2.8l0,0 h-8.5c-3.5,0-6.3-2.8-6.3-6.3c0,0,0,0,0,0v-0.8c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0h77.7c3.5,0,6.3,2.8,6.3,6.3v0.8 c0,3.5-2.8,6.3-6.3,6.3H99.2l0,0h-2.8c-3.7,0-6.7,2.9-6.8,6.6c0,3.7,2.9,6.7,6.6,6.8l0,0h19c3.5,0,6.3,2.8,6.3,6.3c0,0,0,0,0,0 v0.8c0,3.5-2.8,6.3-6.3,6.3c0,0,0,0,0,0L72.4,103.3L72.4,103.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Union_6_00000003081954040188415190000013731161206865213877_",
    gradientUnits: "userSpaceOnUse",
    x1: -142.0199,
    y1: 445.2885,
    x2: -142.0199,
    y2: 444.2885,
    gradientTransform: "matrix(99.671 0 0 -51.554 14398.4961 22920.623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#FF5656"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    style: {
      fill: "url(#Union_6_00000003081954040188415190000013731161206865213877_)"
    },
    d: "M207,15.8 c-3.5,0-6.3-2.8-6.3-6.3V3.4c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0h3.2v0h1.2c2,0,4-0.7,5.5-2.1c1.4-1.3,2.3-3.2,2.3-5.2 c-0.1-3.4-2.5-6.4-5.9-7.1h-10.8c-5,0-9-4-9-9v-0.6c0-5,4-9,9-9h54.8c5,0,9,4,9,9c0,0,0,0,0,0v0.6c0,5-4,9-9,9H242 c-1.4,0.3-2.6,1-3.6,1.9c-1.4,1.3-2.3,3.2-2.3,5.1c0.1,4.1,3.6,7.4,7.7,7.3v0h43c3.5,0,6.3,2.8,6.3,6.3v6.1c0,3.5-2.8,6.3-6.3,6.3 L207,15.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_474_00000052078693484170411740000016727129261028636596_",
    gradientUnits: "userSpaceOnUse",
    x1: -136.0502,
    y1: 431.8557,
    x2: -136.0502,
    y2: 430.8557,
    gradientTransform: "matrix(20.281 0 0 -14.956 3046.1611 6431.0527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#FF5656"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_474",
    style: {
      fill: "url(#Rectangle_474_00000052078693484170411740000016727129261028636596_)"
    },
    d: "M284.3-27.8 h5.3c4.1,0,7.5,3.3,7.5,7.5l0,0c0,4.1-3.3,7.5-7.5,7.5h-5.3c-4.1,0-7.5-3.3-7.5-7.5l0,0C276.8-24.4,280.1-27.8,284.3-27.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_484_00000137829224908833896350000002229604865333638048_",
    gradientUnits: "userSpaceOnUse",
    x1: -134.5567,
    y1: 429.0421,
    x2: -134.5567,
    y2: 428.0421,
    gradientTransform: "matrix(16.911 0 0 -13.02 2293.9446 5649.3247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#FF5656"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_484",
    style: {
      fill: "url(#Rectangle_484_00000137829224908833896350000002229604865333638048_)"
    },
    d: "M16.5,63.2 h3.9c3.6,0,6.5,2.9,6.5,6.5l0,0c0,3.6-2.9,6.5-6.5,6.5h-3.9c-3.6,0-6.5-2.9-6.5-6.5l0,0C10,66.1,12.9,63.2,16.5,63.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_433_00000108297875053050323290000009000101135521521025_",
    gradientUnits: "userSpaceOnUse",
    x1: -130.9642,
    y1: 427.3546,
    x2: -130.9642,
    y2: 426.3546,
    gradientTransform: "matrix(12.082 0 0 -12.082 1691.7407 5121.4756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#FF5656"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_433",
    style: {
      fill: "url(#Ellipse_433_00000108297875053050323290000009000101135521521025_)"
    },
    cx: 109.4,
    cy: -35.8,
    rx: 6,
    ry: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    transform: "translate(17479.588 17796.439)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43.4, -43)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_51-2_00000177452068867902570500000004761359837199351733_",
    gradientUnits: "userSpaceOnUse",
    x1: -150.6889,
    y1: 515.5439,
    x2: -150.6889,
    y2: 514.5439,
    gradientTransform: "matrix(186.872 0 0 -185.81 28302.3516 95794.3906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#FF5656"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_51-2",
    style: {
      opacity: 0.25,
      fill: "url(#Ellipse_51-2_00000177452068867902570500000004761359837199351733_)",
      enableBackground: "new"
    },
    cx: 142.8,
    cy: 94.1,
    rx: 93.4,
    ry: 92.9
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43.4, -43)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_50-2_00000103231000933250695700000008911251096700874898_",
    gradientUnits: "userSpaceOnUse",
    x1: -150.6419,
    y1: 515.4745,
    x2: -150.6419,
    y2: 514.4745,
    gradientTransform: "matrix(176.646 0 0 -177.708 26753.0859 91609.1641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#FF5D5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_50-2",
    style: {
      opacity: 0.5,
      fill: "url(#Ellipse_50-2_00000103231000933250695700000008911251096700874898_)",
      enableBackground: "new"
    },
    cx: 142.8,
    cy: 94.1,
    rx: 88.3,
    ry: 88.9
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43.4, -43)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_49-2_00000183225295404268870140000011665997986436104592_",
    gradientUnits: "userSpaceOnUse",
    x1: -150.5049,
    y1: 515.2099,
    x2: -150.5049,
    y2: 514.2099,
    gradientTransform: "matrix(152.39 0 0 -152.39 23078.2461 78530.0625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#FF5454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49-2",
    style: {
      opacity: 0.75,
      fill: "url(#Ellipse_49-2_00000183225295404268870140000011665997986436104592_)",
      enableBackground: "new"
    },
    cx: 142.8,
    cy: 93.4,
    r: 76.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43.4, -43)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_16690-2_00000023242925688520757930000018058472961244166816_",
    gradientUnits: "userSpaceOnUse",
    x1: -149.4195,
    y1: 513.189,
    x2: -149.4195,
    y2: 512.189,
    gradientTransform: "matrix(72.976 0 0 -72.976 11046.8438 37507.7656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16690-2",
    style: {
      fill: "url(#Path_16690-2_00000023242925688520757930000018058472961244166816_)"
    },
    d: "M142.8,57.3 c20.2,0,36.5,16.3,36.5,36.5s-16.3,36.5-36.5,36.5s-36.5-16.3-36.5-36.5S122.7,57.3,142.8,57.3C142.8,57.3,142.8,57.3,142.8,57.3 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4871",
    transform: "translate(-12.598 -3.992)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Exclusion_3_00000144316505561430118130000017703130465725603508_",
    gradientUnits: "userSpaceOnUse",
    x1: -170.0581,
    y1: 455.2585,
    x2: -170.0581,
    y2: 454.2585,
    gradientTransform: "matrix(12.412 0 0 -12.412 2312.2874 5752.9512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#E83D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_3",
    style: {
      fill: "url(#Exclusion_3_00000144316505561430118130000017703130465725603508_)"
    },
    d: "M201.5,114.7 c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c3.4,0,6.2,2.8,6.2,6.2c0,0,0,0,0,0C207.7,111.9,205,114.7,201.5,114.7z  M201.5,105c-1.9,0-3.4,1.5-3.4,3.4c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4C205,106.6,203.4,105,201.5,105z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Union_11_00000067203739729423766970000003514991782675482514_",
    gradientUnits: "userSpaceOnUse",
    x1: -182.1862,
    y1: 452.5788,
    x2: -182.1862,
    y2: 451.5788,
    gradientTransform: "matrix(11.1337 -5.9136 -5.9138 -11.1341 4710.4478 3922.8186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#E83D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    style: {
      fill: "url(#Union_11_00000067203739729423766970000003514991782675482514_)"
    },
    d: "M9.8-28.2L8-31.6 l-3.3,1.8C4-29.5,3.3-29.7,3-30.3C2.6-31,2.9-31.7,3.5-32l3.3-1.8L5-37.2c-0.3-0.6-0.1-1.4,0.5-1.7s1.4-0.1,1.7,0.5L9-35l3.3-1.8 c0.6-0.3,1.4-0.1,1.7,0.5c0.3,0.6,0.1,1.4-0.5,1.7l-3.3,1.8l1.8,3.3c0.3,0.6,0.1,1.4-0.5,1.7C10.9-27.4,10.1-27.6,9.8-28.2 L9.8-28.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Union_12_00000005979290643212718990000006205299326724498563_",
    gradientUnits: "userSpaceOnUse",
    x1: 17282.875,
    y1: 18263.2773,
    x2: 17282.332,
    y2: 18262.7344,
    gradientTransform: "matrix(30.9006 -30.9006 -30.9006 -30.9006 47873.9609 1116225.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5454"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_12",
    style: {
      fill: "url(#Union_12_00000005979290643212718990000006205299326724498563_)"
    },
    d: "M17592.8,17865.6 c-0.8,0.8-2,0.8-2.8,0l-10.9-10.9l-10.9,10.9c-0.8,0.8-2,0.8-2.8,0l-3.4-3.4c-0.8-0.8-0.8-2,0-2.8l10.9-10.9l-10.9-10.9 c-0.8-0.8-0.8-2,0-2.8l3.4-3.4c0.8-0.8,2-0.8,2.8,0l10.9,10.9l10.9-10.9c0.8-0.8,2-0.8,2.8,0l3.4,3.4c0.8,0.8,0.8,2,0,2.8 l-10.9,10.9l10.9,10.9c0.8,0.8,0.8,2,0,2.8L17592.8,17865.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateError);
export default __webpack_public_path__ + "static/media/state-error.fef7a16522bab8543ae6017bedf7140c.svg";
export { ForwardRef as ReactComponent };